import { useQuery } from 'react-query';

import { GridRowsProp } from '@mui/x-data-grid';
import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';

import APIs from '../../../../../api';
import TableTemplate from '../../../../../components/Layout/TableTemplate';
import { usePermission } from '../../../../../hooks';
import { useGenTableColumns } from '../../../../../hooks/useTable';
import useTranslation from '../../../../../hooks/useTranslation';
import { useZusDialogStore } from '../../../../../zustand/store';
import { getTabTranslatePrefix } from '../../helper';
import { useListMapping, useZusParams } from '../hooks';
import { filterTableTranslateKey as TableTK } from '../mappings/translate';

const api = {
  table: APIs.programAgentManagement.custodyWallet.historyTab.getAll,
  export: APIs.programAgentManagement.custodyWallet.historyTab.getExport,
};
export default function Table() {
  const { hasPermission } = usePermission();
  const translatePrefix = getTabTranslatePrefix('historyTab');
  const exportFileName = 'Custody Wallet History';
  const exportPermissionKey =
    AgentPortalFeatureCode.ProgramAgentManagement.CustodyWallet.HistoryTab.Export;

  const zusParams = useZusParams();
  const zusDialog = useZusDialogStore();

  const { t, tc } = useTranslation(translatePrefix);

  const listRes = useQuery({
    queryKey: [translatePrefix, zusParams.body, zusParams.refetchCounter],
    queryFn: () => {
      zusDialog.openExtra('loadingDialog');
      return api.table(zusParams.body);
    },
    onSettled: () => zusDialog.closeExtra(),
  });

  const { rows = [], count = 0 } = listRes.data || {};

  const tableMapping = useListMapping('table');
  const exportMapping = useListMapping('export');

  const omitKeys: string[] = [];

  const content: GridRowsProp = tableMapping(rows, omitKeys);

  const { columns } = useGenTableColumns([
    { translateKey: TableTK.ledgerClientId, minWidth: 150 },
    { translateKey: TableTK.pfhNumber, minWidth: 150 },
    { translateKey: TableTK.currency },
    { translateKey: TableTK.amount },
    { translateKey: TableTK.frozenBalance },
    { translateKey: TableTK.postBalance },
    { translateKey: TableTK.lastLedgerTransactionId, minWidth: 150 },
    { translateKey: TableTK.sendingAddress, minWidth: 150 },
    { translateKey: TableTK.receivingAddress, minWidth: 150 },
    { translateKey: TableTK.transactionHash, minWidth: 150 },
    { translateKey: TableTK.referenceNumber, minWidth: 150 },
    { translateKey: TableTK.riskLevel, minWidth: 150 },
    { translateKey: TableTK.transactionStatus, minWidth: 150 },
    // { translateKey: TableTK.transactionType },
    { translateKey: TableTK.sendingClientId, minWidth: 150 },
    { translateKey: TableTK.receivingClientId, minWidth: 150 },
    { translateKey: TableTK.creationTime },
    { translateKey: TableTK.lastModifiedTime },
  ]);

  return (
    <TableTemplate
      exportBtn={{
        fileName: exportFileName,
        permissionKey: exportPermissionKey,
        apiFn: api.export,
        omitKeys: ['rawData'],
        mappingFn: exportMapping,
      }}
      zusParams={zusParams}
      count={count}
      content={content}
      columns={columns}
    />
  );
}
